import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQ_ITEMS = [
  {
    question: "Como funciona a primeira consulta?",
    answer:
      "A consulta é um momento de escuta e avaliação detalhada. O Dr. Yago analisará suas características, ouvirá seus objetivos e, a partir disso, apresentará um plano de tratamento personalizado. É a etapa mais importante do processo — dedicada a alinhar expectativas e construir confiança.",
  },
  {
    question: "Qual o valor dos procedimentos?",
    answer:
      "Cada paciente é único, assim como cada planejamento cirúrgico. Os valores são definidos após avaliação individual, considerando complexidade, técnicas envolvidas e estrutura necessária. Agende uma consulta para receber um orçamento personalizado.",
  },
  {
    question: "Como é o pós-operatório?",
    answer:
      "O acompanhamento pós-operatório é rigoroso e próximo. São utilizadas técnicas que priorizam menor desconforto e recuperação otimizada. Consultas de retorno e suporte direto da equipe fazem parte do processo para assegurar os melhores resultados.",
  },
  {
    question: "Quais tecnologias são utilizadas?",
    answer:
      "A escolha da tecnologia empregada depende de cada caso e é definida de forma personalizada durante a consulta, sempre visando o melhor resultado para o paciente.",
  },
  {
    question: "A cirurgia é segura?",
    answer:
      "Segurança é inegociável. Todos os procedimentos cirúrgicos são realizados em ambiente hospitalar com equipe completa e estrutura adequada. O Dr. Yago possui dupla certificação pela Sociedade Brasileira de Cirurgia Plástica — em Cirurgia Geral e em Cirurgia Plástica.",
  },
  {
    question: "Onde são realizados os procedimentos?",
    answer:
      "As consultas e atendimentos são realizados na Moriá Saúde, localizada na Av. Adolfo Fetter, 3419 (sala 5), Laranjal, em Pelotas/RS. Os procedimentos cirúrgicos são realizados em ambiente hospitalar, com toda a infraestrutura necessária para sua segurança.",
  },
  {
    question: "É possível fazer uma consulta a distância?",
    answer:
      "Sim. Para pacientes de outras cidades, oferecemos avaliação online como primeiro contato. O acompanhamento pré e pós-operatório pode ser conduzido à distância, sendo necessário o deslocamento apenas para a realização do procedimento.",
  },
];

export const FAQSection = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-28 md:py-40 bg-[#F3F3F3]">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <p className="font-body text-gold text-xs font-medium tracking-[0.35em] uppercase mb-4">
            Dúvidas Frequentes
          </p>
          <h2 className="font-heading text-navy text-4xl md:text-5xl font-medium leading-tight">
            Perguntas e Respostas
          </h2>
          <div className="gold-line mt-6" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          <Accordion type="single" collapsible className="space-y-2" data-testid="faq-accordion">
            {FAQ_ITEMS.map((item, idx) => (
              <AccordionItem
                key={idx}
                value={`faq-${idx}`}
                className="border-b border-navy/[0.06] bg-transparent"
                data-testid={`faq-item-${idx}`}
              >
                <AccordionTrigger className="font-body text-navy text-[15px] font-medium py-6 hover:no-underline hover:text-gold transition-colors duration-300">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="font-body text-navy/55 text-sm leading-[1.8] pb-6">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
